import { formatDate } from "@/util/parseTime";
export function loadSqChart(myChart, obj, unit, type = "3", istody = false) {
  let data10 = [];
  let data20 = [];
  let data30 = [];
  let date = [];
  let series;
  let formatdates = istody ? "yyyy-MM-dd" : "MM-dd hh";
  if (type === "3") {
    for (let i = 0; i < obj.length; i++) {
      let time1 = obj[i].date + ":00";
      let time = formatDate(new Date(time1), formatdates);
      date.push(time);
      data10.push(obj[i].value10);
      data20.push(obj[i].value20);
      data30.push(obj[i].value30);
    }
    series = [
      {
        name: "10CM",
        type: "line",
        smooth: true, //是否平滑
        showAllSymbol: true,
        // symbol: 'image://./static/images/guang-circle.png',
        symbol: "circle",
        symbolSize: 0,
        lineStyle: {
          normal: {
            color: "rgb(255,133,14)",
            shadowColor: "rgba(0, 0, 0, 0)",
            shadowBlur: 0,
            shadowOffsetY: 5,
            shadowOffsetX: 5
          }
        },
        label: {
          show: false,
          position: "top",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        itemStyle: {
          color: "rgb(255,133,14)",
          borderColor: "rgb(0,115,100)",
          borderWidth: 0,
          shadowColor: "rgba(0, 0, 0, 0)",
          shadowBlur: 0,
          shadowOffsetY: 0,
          shadowOffsetX: 0
        },
        tooltip: {
          show: true
        },
        data: data10
      },
      {
        name: "20CM",
        type: "line",
        smooth: true, //是否平滑
        showAllSymbol: true,
        // symbol: 'image://./static/images/guang-circle.png',
        symbol: "circle",
        symbolSize: 0,
        lineStyle: {
          normal: {
            color: "rgb(1,255,251)",
            shadowColor: "rgba(0, 0, 0, 0)",
            shadowBlur: 0,
            shadowOffsetY: 5,
            shadowOffsetX: 5
          }
        },
        label: {
          show: false,
          position: "top",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        itemStyle: {
          color: "rgb(1,255,251)",
          borderColor: "rgb(255,115,100)",
          borderWidth: 0,
          shadowColor: "rgba(0, 0, 0, 0)",
          shadowBlur: 0,
          shadowOffsetY: 0,
          shadowOffsetX: 0
        },
        tooltip: {
          show: true
        },
        data: data20
      },
      {
        name: "40CM",
        type: "line",
        smooth: true, //是否平滑
        showAllSymbol: true,
        // symbol: 'image://./static/images/guang-circle.png',
        symbol: "circle",
        symbolSize: 0,
        lineStyle: {
          normal: {
            color: "rgb(14,156,255)",
            shadowColor: "rgba(0, 0, 0, 0)",
            shadowBlur: 0,
            shadowOffsetY: 5,
            shadowOffsetX: 5
          }
        },
        label: {
          show: false,
          position: "top",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        itemStyle: {
          color: "rgb(14,156,255)",
          borderColor: "rgb(255,115,100)",
          borderWidth: 0,
          shadowColor: "rgba(0, 0, 0, 0)",
          shadowBlur: 0,
          shadowOffsetY: 0,
          shadowOffsetX: 0
        },
        tooltip: {
          show: true
        },
        data: data30
      }
    ];
  } else {
    for (let i = 0; i < obj.length; i++) {
      let time1 = obj[i].date + ":00";
      let time = formatDate(new Date(time1), formatdates);
      date.push(time);
      data10.push(obj[i].value10);
    }
    series = [
      {
        name: "",
        type: "line",
        smooth: true, //是否平滑
        showAllSymbol: true,
        // symbol: 'image://./static/images/guang-circle.png',
        symbol: "circle",
        symbolSize: 0,
        lineStyle: {
          normal: {
            color: "rgb(255,133,14)",
            shadowColor: "rgba(0, 0, 0, 0)",
            shadowBlur: 0,
            shadowOffsetY: 5,
            shadowOffsetX: 5
          }
        },
        label: {
          show: false,
          position: "top",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        itemStyle: {
          color: "rgb(255,133,14)",
          borderColor: "rgb(0,115,100)",
          borderWidth: 0,
          shadowColor: "rgba(0, 0, 0, 0)",
          shadowBlur: 0,
          shadowOffsetY: 0,
          shadowOffsetX: 0
        },
        tooltip: {
          show: true
        },
        data: data10
      }
    ];
  }
  myChart.clear();
  myChart.setOption({
    legend: {
      show: type === "3",
      icon: "circle",
      orient: "horizontal",
      top: "2%",
      left: "2%",
      itemWidth: 10,
      itemHeight: 8,
      itemGap: 5,
      textStyle: {
        // color: '#FFFFFF'
        color: "#fff",
        fontSize: 10
      }
    },

    tooltip: {
      trigger: "axis",
      axisPointer: {
        lineStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "rgba(0, 255, 233,0)"
              },
              {
                offset: 0.5,
                color: "rgba(255, 255, 255,1)"
              },
              {
                offset: 1,
                color: "rgba(0, 255, 233,0)"
              }
            ],
            global: false
          }
        }
      }
    },
    grid: {
      top: "20%",
      left: "5%",
      right: "5%",
      bottom: "0%",
      containLabel: true
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: true
        },
        splitArea: {
          // show: true,
          color: "#f00",
          lineStyle: {
            color: "#f00"
          }
        },
        axisLabel: {
          color: "#fff"
        },
        splitLine: {
          show: false
        },
        boundaryGap: false,
        data: date
      }
    ],

    yAxis: [
      {
        type: "value",
        name: unit,
        nameGap: 8,
        nameTextStyle: {
          color: "#fff"
        },
        min: function(value) {
          return value.min;
        },
        max: function(value) {
          return value.max;
        },
        // max: 30,
        // splitNumber: 4,
        splitLine: {
          show: true,
          lineStyle: {
            color: ["#fff"],
            opacity: 0.06
          }
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: true,
          margin: 20,
          textStyle: {
            fontSize: 10,
            color: "rgba(255,255,255,0.5)"
          }
        },
        axisTick: {
          show: false
        }
      }
    ],
    series: series
  });
}
